import { Box, Typography } from '@mui/material'
import CustomCheckbox from '../components/Inputs/CustomCheckbox'
import CustomOption from '../components/Inputs/CustomOption'
import CustomSlider from '../components/Inputs/CustomSlider'

const Planning = () => {
  return (
    <Box sx={{ padding: '20px 0px 40px 0px' }}>
      <Typography sx={{ mb: 3, pt: 2 }} className="general-text-light">
        <span className="general-text">Task Name: </span>Planning
      </Typography>
      <Typography sx={{ mb: 3 }} className="general-text">
        Hazardous Elements
      </Typography>
      <CustomCheckbox
        label="Hazardous Materials"
        name="Hazardous_Materials"
        component={
          <Box>
            <Typography className="general-text">
              What are the hazards and risks?
            </Typography>
            <CustomOption
              label="Presence of hazardous material - Lead and / or Asbestos :"
              name="presence_of_hazardous_material"
              warning="Is it a risk at this site?"
              component={
                <Box>
                  <CustomSlider
                    label="Inherent Risk Rating - (Presence of hazardous material - Lead and / or Asbestos)"
                    name="inherent_risk_rating_presence"
                  />
                  <Typography color="primary" className="general-text">
                    How will the hazards and risk be controlled?
                  </Typography>
                  <Typography className="general-text">
                    Review site hazardous materials register, follow internal
                    safe work processes and practices for working with or
                    surrounding these materials
                  </Typography>
                  <CustomSlider
                    label="Residual Risk Rating - (Presence of Hazardous materials)"
                    name="residual_risk_rating_presence"
                  />
                </Box>
              }
            />
          </Box>
        }
        conditional_heading="Hazardous Material"
      />
    </Box>
  )
}

export default Planning
